export interface CreateCustomVaultCategory {
  name: string;
}

export interface CreateCustomVaultCategoryResponse {
  id: number;
  name: string;
  restaurantId: number;
  isCustom: boolean;
  createdBy: number;
  createdAt: Date;
}

export interface UpdateCustomVaultCategoryResponse {
  id: number;
  name: string;
  restaurantId: number;
  isCustom: boolean;
  createdBy: number;
  createdAt: Date;
}

export interface GetVaultCategoriesQuery {
  isCustom?: boolean;
}
export interface UpdateVaultCategoriesQuery {
  shouldDelete?: boolean;
  name?: string;
}

export interface GetVaultCategoryResponse {
  id: number;
  name: string;
  restaurantId: number;
  isCustom: boolean;
  createdBy: number;
  createdAt: Date;
}

export enum vaultItemType {
  FOLDER = 'folder',
  IMAGE = 'image',
  PDF = 'pdf',
}

export enum VAULT_ITEM_DEFAULT_CATEGORIES {
  EMPLOYEES = 'Employees',
  VENDORS = 'Vendors',
  CONTRACTS = 'Contracts',
  ALCOHOL_AND_BEVERAGES = 'Alcohol & Beverages',
  TAXES = 'Taxes',
  BUILDINGS = 'Buildings',
}

export interface CreateVaultItemBodyType {
  name: string;
  parentFolderId: number;
  categoryId: number;
  file: any;
}
export interface CetvaultItemsQueryType {
  parentFolder: number;
}
export interface UpdateVaultItemBodyType {
  shouldDelete?: boolean;
  name?: string;
}

export interface CreateVaultItemResponseType {
  id: number;
  name: string;
  type: vaultItemType;
  URL: string;
}

export interface UpdateVaultItemResponseType {
  id: number;
  name: string;
  type: vaultItemType;
  URL: string;
}

export interface GetVaultItemsResponseType {
  id: number;
  name: string;
  type: vaultItemType;
  URL: string;
}

export interface GetVaultStatsResponseType {
  docsCount: number;
}
